const l = {
  name: "SouthKoreanWon",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M26.4,20l0.5-3h2v-2h-1.7l0.7-4h-2l-0.7,4h-3.7L21,11.8L20.8,11h-1.7l-0.8,4h-3.7L14,11h-2l0.7,4H11v2h2
			l0.5,3H11v2h2.9l1.2,7h2.7l1.3-7h1.7l1.3,7h2.7l1.2-7H29v-2H26.4z M24.4,20h-1.9L22,17h3L24.4,20z M24.1,22l-0.6,3.2L22.9,22H24.1
			z M20.5,20h-1l0.5-2.6L20.5,20z M17.5,20h-1.9l-0.5-3h3L17.5,20z M17.1,22l-0.6,3.2L16,22H17.1z"/>
		<path class="st0" d="M20,0C9,0,0,9,0,20s9,20,20,20c11,0,20-9,20-20S31.1,0,20,0z M2,20c0-9.9,8.1-18,18-18c9.9,0,18,8.1,18,18
			s-8.1,18-18,18C10.1,38,2,29.9,2,20z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as SouthKoreanWon
};
